"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAbcInsurers = void 0;
const vue_1 = require("vue");
const abcRepository_1 = __importDefault(require("../app/abc/infraestructure/repositories/abcRepository"));
function useAbcInsurers() {
    const isLoading = (0, vue_1.ref)(false);
    const isSuccess = (0, vue_1.ref)(false);
    const isError = (0, vue_1.ref)(false);
    const error = (0, vue_1.ref)("");
    const fetch = async (props) => {
        try {
            isLoading.value = true;
            const response = await (0, abcRepository_1.default)().getAllInsurers(props.plazo, props.powerTrain.price, props.powerTrain.trim?.model?.year, props.powerTrain.aplics_eikos_id, props.slug);
            isSuccess.value = true;
            return response;
        }
        catch (e) {
            isError.value = true;
            error.value = e;
        }
        finally {
            isLoading.value = false;
        }
        return null;
    };
    return { isLoading, isSuccess, isError, error, fetch };
}
exports.useAbcInsurers = useAbcInsurers;
